import React from 'react';

const Footer = () => {
  return (
    <footer id="footer" className="bg-gray-900 text-white py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-8">Get In Touch.</h2>
        </div>

        <div className="grid md:grid-cols-2 gap-12 mb-12">
          <div>
            <p className="text-xl text-gray-300 mb-8">
              Ready to create stunning fashion photography that captures your vision? 
              Located in the heart of Penarth Marina, we're here to bring your creative 
              ideas to life with professional excellence and artistic flair.
            </p>
          </div>

          <div className="grid sm:grid-cols-2 gap-8">
            <div>
              <h5 className="text-lg font-semibold mb-4">Follow Us</h5>
              <ul className="space-y-2 text-gray-300">
                <li><a href="#0" className="hover:text-white transition-colors">Instagram</a></li>
                <li><a href="#0" className="hover:text-white transition-colors">Facebook</a></li>
                <li><a href="#0" className="hover:text-white transition-colors">Pinterest</a></li>
                <li><a href="#0" className="hover:text-white transition-colors">Behance</a></li>
              </ul>
            </div>
            <div>
              <h5 className="text-lg font-semibold mb-4">Contact Info</h5>
              <ul className="space-y-2 text-gray-300">
                <li><a href="mailto:hello@pixelperfect.com" className="hover:text-white transition-colors">hello@pixelperfect.com</a></li>
                <li><a href="tel:+442920123456" className="hover:text-white transition-colors">+44 29 2012 3456</a></li>
                <li className="text-sm">Compass House, Portway<br />Penarth Marina, CF64 1TT</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="grid sm:grid-cols-2 gap-4 mb-12">
          <a 
            href="mailto:hello@pixelperfect.com" 
            className="bg-white text-gray-900 px-8 py-4 rounded-lg text-center font-semibold hover:bg-gray-100 transition-colors"
          >
            Book a Session
          </a>
          <a 
            href="#0" 
            className="border-2 border-white text-white px-8 py-4 rounded-lg text-center font-semibold hover:bg-white hover:text-gray-900 transition-colors"
          >
            View Portfolio
          </a>
        </div>

        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="flex space-x-6 mb-4 md:mb-0">
              <a href="#0" className="text-gray-400 hover:text-white transition-colors">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z"/>
                </svg>
              </a>
              <a href="#0" className="text-gray-400 hover:text-white transition-colors">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12.017 0C5.396 0 .029 5.367.029 11.987c0 5.079 3.158 9.417 7.618 11.174-.105-.949-.199-2.403.041-3.439.219-.937 1.406-5.957 1.406-5.957s-.359-.72-.359-1.781c0-1.663.967-2.911 2.168-2.911 1.024 0 1.518.769 1.518 1.688 0 1.029-.653 2.567-.992 3.992-.285 1.193.6 2.165 1.775 2.165 2.128 0 3.768-2.245 3.768-5.487 0-2.861-2.063-4.869-5.008-4.869-3.41 0-5.409 2.562-5.409 5.199 0 1.033.394 2.143.889 2.741.099.12.112.225.085.347-.09.375-.293 1.199-.334 1.363-.053.225-.172.271-.402.165-1.495-.69-2.433-2.878-2.433-4.646 0-3.776 2.748-7.252 7.92-7.252 4.158 0 7.392 2.967 7.392 6.923 0 4.135-2.607 7.462-6.233 7.462-1.214 0-2.357-.629-2.75-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24.009 12.017 24.009c6.624 0 11.99-5.367 11.99-11.988C24.007 5.367 18.641.001.012.001z"/>
                </svg>
              </a>
            </div>
            
            <div className="text-center text-gray-400">
              <p>© Copyright Pixel Perfect 2024 - Fashion Photography Gallery</p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;